import { Typography } from '@mui/material'
import type { ItemProps } from '../types'
import { styles } from '../style'

/**
 * Base typography wrapper used by formula sub-components (Value, Prefix, Suffix) to render styled text.
 */
export function Item(props: ItemProps) {
  return (
    <Typography
      sx={styles.item}
      variant='h5'
      fontWeight='medium'
      data-disabled={props.disabled}
      color='default'
      {...props.TypographyProps}
    >
      {props.children}
    </Typography>
  )
}
